export default class AppConfig {
}
AppConfig.REST = {
    URL: process.env.REST_URL
};
